var _mask;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskAndProfitIndex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 315,
    viewBox: "0 0 315 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M306.184 173.095C310.579 173.556 314.536 170.367 314.773 165.955C316.007 142.995 312.201 120.009 303.582 98.6235C294.962 77.2378 281.766 58.0363 264.955 42.3495C261.725 39.3351 256.662 39.7815 253.816 43.1607L248.904 48.9923C246.057 52.3715 246.507 57.4014 249.711 60.4446C263.583 73.6248 274.493 89.6493 281.669 107.455C288.846 125.261 292.097 144.372 291.241 163.488C291.043 167.902 294.207 171.838 298.601 172.299L306.184 173.095Z",
    fill: "#1CD54F",
    style: {
      fill: "#1CD54F",
      fill: "color(display-p3 0.1088 0.8367 0.3113)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6081 40.3618C61.8628 36.9 56.8158 36.304 53.4978 39.2216C35.9212 54.6765 21.9835 73.879 12.7368 95.4528C3.49001 117.027 -0.804682 140.362 0.123972 163.749C0.299279 168.163 4.21132 171.407 8.61152 171.008L16.2053 170.319C20.6055 169.92 23.8239 166.028 23.6881 161.612C23.0895 142.136 26.7496 122.729 34.4513 104.76C42.1529 86.791 53.6832 70.7573 68.2005 57.7597C71.4922 54.8126 72.0912 49.7981 69.3459 46.3363L64.6081 40.3618Z",
    fill: "#FF3131",
    style: {
      fill: "#FF3131",
      fill: "color(display-p3 1.0000 0.1933 0.1933)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2506 36.8257C66.6425 33.2593 67.4092 28.235 71.1034 25.8113C97.1973 8.69142 127.849 -0.324439 159.176 0.00891636C190.503 0.342271 220.956 10.0083 246.679 27.6797C250.321 30.1814 250.981 35.2208 248.297 38.7309L243.666 44.7885C240.983 48.2986 235.975 48.9469 232.311 46.4779C210.656 31.8861 185.151 23.9117 158.924 23.6326C132.698 23.3535 107.029 30.7834 85.0689 44.9111C81.3531 47.3016 76.3597 46.5468 73.7516 42.9804L69.2506 36.8257Z",
    fill: "#FFC700",
    style: {
      fill: "#FFC700",
      fill: "color(display-p3 1.0000 0.7800 0.0000)",
      fillOpacity: 1
    }
  }), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_175_1455",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279 171.5C279 136.491 266.199 102.917 243.413 78.1619C220.628 53.4071 189.724 39.5 157.5 39.5C125.276 39.5 94.3722 53.4071 71.5865 78.1619C48.8009 102.917 36 136.491 36 171.5L37.8146 171.5C37.8146 137.014 50.4243 103.941 72.8696 79.5559C95.315 55.1708 125.757 41.4714 157.5 41.4714C189.243 41.4714 219.685 55.1708 242.13 79.5559C264.576 103.941 277.185 137.014 277.185 171.5H279Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279 171.5C279 136.491 266.199 102.917 243.413 78.1619C220.628 53.4071 189.724 39.5 157.5 39.5C125.276 39.5 94.3722 53.4071 71.5865 78.1619C48.8009 102.917 36 136.491 36 171.5L37.8146 171.5C37.8146 137.014 50.4243 103.941 72.8696 79.5559C95.315 55.1708 125.757 41.4714 157.5 41.4714C189.243 41.4714 219.685 55.1708 242.13 79.5559C264.576 103.941 277.185 137.014 277.185 171.5H279Z",
    stroke: "#7A7A7A",
    style: {
      stroke: "#7A7A7A",
      stroke: "color(display-p3 0.4784 0.4784 0.4784)",
      strokeOpacity: 1
    },
    strokeWidth: 6,
    strokeDasharray: "2 16",
    mask: "url(#path-4-inside-1_175_1455)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskAndProfitIndex);
export default __webpack_public_path__ + "static/media/RiskAndProfitIndex.7a172c3416966536e756d6ab5252ecfe.svg";
export { ForwardRef as ReactComponent };